import { useEffect, useState } from 'react';
import { NumericFormat } from 'react-number-format';
import { Controller } from "react-hook-form";
import * as S from './style';
//Icons
import { Plus, Trash } from "@phosphor-icons/react";

interface ICreat {
    register: any,
    errors: any,
    reset: any,
    getValues: any,
    resetField: any,
    control: any,
    setValue: any,
    creditPromotions?: Array<{ installment: number, discount: string }>
}
export default function AddiotionInputs({
    errors,
    getValues,
    control,
    setValue,
    creditPromotions = [] // Novo parâmetro para receber os dados da API
}: ICreat) {

    // const [paymentAmount, setPaymentAmount] = useState<number[]>([1]);

    // Inicializar o estado baseado nos dados recebidos ou com o valor padrão [1]
    const [paymentAmount, setPaymentAmount] = useState<number[]>(() => {
        if (creditPromotions && creditPromotions.length > 0) {
            // Criar um array com base nos dados da API
            return creditPromotions.map((_, index) => index + 1);
        }
        return [1]; // Valor padrão se não houver dados
    });

    // Efeito para preencher os valores quando o componente montar ou quando creditPromotions mudar
    useEffect(() => {
        if (creditPromotions && creditPromotions.length > 0) {
            creditPromotions.forEach((item, index) => {
                // Preencher o valor do desconto
                setValue(`creditPromotions.${index}.discount`, parseFloat(item.discount));
                // Preencher o valor da parcela
                setValue(`creditPromotions.${index}.installment`, item.installment);
            });
        }
    }, [creditPromotions, setValue]);

    const addPayment = () => {
        setPaymentAmount([...paymentAmount, paymentAmount.length + 1]);
    };

    const removePayment = (indexToRemove: number) => {
        if (paymentAmount.length > 1) {
            // Atualizar o array de pagamentos
            const updatedPayments = paymentAmount.filter((_, index) => index !== indexToRemove);
            setPaymentAmount(updatedPayments);

            // Obter os valores atuais do formulário
            const currentValues = getValues();

            // Criar um novo array de promoções sem os itens removidos
            const updatedPromotions = currentValues.creditPromotions.filter((_: any, index: number) => index !== indexToRemove);


            // Atualizar os índices dos installments restantes
            updatedPromotions.forEach((promotion: any, idx: any) => {
                promotion.installment = idx + 1;
            });

            // Atualizar o formulário com os novos valores
            setValue('creditPromotions', updatedPromotions);

        }
    };

    return (
        <S.Content>
            <S.Title>
                Desconto no Crédito (%)
                <span>*</span>
            </S.Title>

            {
                paymentAmount.map((val, index) => {
                    const count = index + 1;
                    return (
                        <S.Forms key={val}>
                            <S.FormInput>
                                <S.Label>
                                    {count}x
                                </S.Label>

                                <Controller
                                    name={`creditPromotions.${index}.discount`}
                                    rules={{ required: "Campo Obrigatório" }}
                                    control={control}
                                    render={({ field: { onChange, value, ref } }) => (
                                        <NumericFormat
                                            thousandSeparator="."
                                            decimalSeparator=","
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            placeholder="0,00 %"
                                            suffix=" %"
                                            value={value}
                                            onValueChange={(values) => {
                                                const discountValue = values.floatValue ?? 0;
                                                setValue(`creditPromotions.${index}.installment`, count);
                                                onChange(discountValue);
                                            }}
                                            getInputRef={ref}
                                        />
                                    )}
                                />
                                {paymentAmount.length > 1 && (
                                    <S.ButtonRemove onClick={() => removePayment(index)}>
                                        <Trash size={16} />
                                    </S.ButtonRemove>
                                )}
                            </S.FormInput>
                            {errors.creditPromotions?.[index]?.discount && (
                                <S.InforErro>Campo Obrigatório</S.InforErro>
                            )}
                        </S.Forms>
                    )
                })
            }

            <S.Button onClick={addPayment}>
                <Plus size={12} />
                Parcelas
            </S.Button>
        </S.Content >
    )
}